import script from "./EditorSide.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorSide.vue?vue&type=script&setup=true&lang=ts"

import "./EditorSide.vue?vue&type=style&index=0&id=45b90ad1&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b90ad1"]])

export default __exports__